export const defaultLocale = 'en'
export const fallbackLocale = 'en'

const publicPath = process.env.VUE_APP_BASE_URL;

const files = require.context(
    '.', // current directory
    true, // subdirectories
    /.+\.json$/ // only .json
)

let ru={}
let en={}

files.keys().forEach(fileName => {

    let name = fileName.replace('.json', '').replace('./', '');
    let parts = name.split('/');

    if ( parts[0]==='en') {
        en = {...en,...files(fileName)};
    }
    if ( parts[0]==='ru') {
        ru = {...ru,...files(fileName)};
    }

})


/**
 * Подгружаемые словари
 */
export const languages = {
    en, ru
}

/**
 * Языки, доступные в селекторе языков
 */
export const langswlist = [
    'en', 'ru'
]
